<template>
  <span
    :class="['badge badge-pill', styles]"
  >
    {{ type }}
  </span>
</template>
<script>
export default {
  name: "IncidentPill",
  props: {
    link: {
      type: Boolean,
      default: false
    },
    // From incident in v-bind:
    id: {
      type: Number,
      default: null
    },
    participant_id: {
      type: Number,
      default: null
    },
    study_id: {
      type: String,
      default: null
    },
    priority: {
      type: String,
      default: 'Medium'
    },
    type: {
      type: String,
      // required but should usually be in v-bind
    },
  },
  computed: {
    styles() {
      switch(this.priority) {
        case 'High':
          return 'badge-danger';
        default:
        case 'Medium':
          return 'badge-warning';
        case 'Low':
          return 'badge-info';
      }
    }
  }
}
</script>